import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import LiquidacionMercaderiaZarandeadaView from '../../components/listados/LiquidacionMercaderiaZarandeadaView'
import { obtenerTotalZarandeo } from '../../actions/listados'

function LiquidacionMercaderiaZarandeada (props) {
  const { obtenerTotalZarandeo } = props

  useEffect(() => {
    obtenerTotalZarandeo(new Date(), new Date())
  }, [obtenerTotalZarandeo])

  const actualizarFechas = (fechaD, fechaH) => {
    obtenerTotalZarandeo(fechaD, fechaH)
  }

  return (
    <>
      <div className='container-entre-fechas' style={{ margin: '-3% auto 0 auto' }}>
        <DatePicker
          selectRange
          disabledFuture
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>
      <LiquidacionMercaderiaZarandeadaView />
    </>
  )
}

const mapActionsToProps = {
  obtenerTotalZarandeo
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(LiquidacionMercaderiaZarandeada)
